import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {BsFolderCheck} from 'react-icons/bs'
const about = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className='container about__container'>
        <div className='about__me' data-aos="fade-right" data-aos-delay="100">
          <div className='about__me-image'>
            <img src={ME} alt="About Image" />
          </div>
        </div>
      

      <div className='about__content' data-aos="fade-left" data-aos-delay="100">
        <div className='about__cards'>
          <article className='about__card' data-aos="fade-up" data-aos-delay="200">
            <FaAward className='about__icon'/>
            <h5>Experience</h5>
            <small>3+ years</small>
          </article>
          <article className='about__card' data-aos="fade-up" data-aos-delay="300">
            <FiUsers className='about__icon'/>
            <h5>Practical Experience</h5>
            <small>6 projects</small>
          </article>
          <article className='about__card' data-aos="fade-up" data-aos-delay="400">
            <BsFolderCheck className='about__icon'/>
            <h5>Projects</h5>
            <small>15+ Completed</small>
          </article>
        </div>
        <p data-aos="fade-up" data-aos-delay="500">
        As a highly motivated and dedicated individual, I am passionate about continuously learning and expanding my skillset. With a background in web and software development, I possess a broad range of abilities and experiences. I am a self-starter who takes initiative and works hard to complete projects to the best of my abilities.
        </p>
        <a href="#contact" class="btn btn-primary" data-aos="fade-up" data-aos-delay="600">Let's Talk</a>
      </div>
      </div>
    </section>
  )
}

export default about